import { observer } from 'mobx-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { gray15 } from '../../../platform/color'
import Table from './Table'
import { Animated } from './utils'

const DetailsColumn: React.FC<{ title: string; artistEthAddress: string; artistName: string }> = ({
  title,
  artistEthAddress,
  artistName
}) => (
  <>
    <Table.Text bold size={'14'} css={{ color: gray15, whiteSpace: 'nowrap' }}>
      <Animated id={'animated'}>{title}</Animated>
    </Table.Text>
    <Table.Text medium size={'14'} css={{ whiteSpace: 'nowrap' }} link>
      <Animated id={'animated'} css={{ '&:hover': { textDecoration: 'underline' } }}>
        <Link to={`/profile/${artistEthAddress}`}>{artistName}</Link>
      </Animated>
    </Table.Text>
  </>
)

export default observer(DetailsColumn)
